import React from 'react';

const AdminToast = ({ message, type, onClose }) => {
    const baseClasses = "p-4 rounded-lg shadow-lg flex items-center gap-2 min-w-64 max-w-96 animate-slide-in";

    const typeClasses = {
        success: "bg-green-500 text-white",
        error: "bg-red-500 text-white",
        info: "bg-blue-500 text-white",
        warning: "bg-yellow-500 text-black"
    };

    const icons = {
        success: "✓",
        error: "✕",
        info: "ℹ",
        warning: "⚠"
    };

    return (
        <div className={`${baseClasses} ${typeClasses[type] || typeClasses.info}`}>
            <span className="text-lg">{icons[type] || icons.info}</span>
            <span className="flex-1">{message}</span>
            {onClose && (
                <button
                    onClick={onClose}
                    className="ml-2 text-lg hover:opacity-70"
                >
                    ×
                </button>
            )}
        </div>
    );
};

export default AdminToast;